import React from 'react';

export default function SectionCard({ comp }) {
  const shadow =
    comp.shadow === 'sm' ? '0 1px 4px rgba(0,0,0,.06)' :
    comp.shadow === 'md' ? '0 4px 16px rgba(0,0,0,.1)' : 'none';

  return (
    <div style={{
      width: '100%', height: '100%', overflow: 'hidden', boxSizing: 'border-box',
      background: comp.bg || '#fff',
      borderRadius: comp.borderRadius || 10,
      border: comp.borderEnabled
        ? `${comp.borderWidth || 1}px ${comp.borderStyle || 'solid'} ${comp.borderColor || '#E2E5EA'}`
        : 'none',
      boxShadow: shadow,
      padding: `${comp.padT ?? 20}px ${comp.padR ?? 20}px ${comp.padB ?? 20}px ${comp.padL ?? 20}px`,
      display: 'flex', flexDirection: 'column', gap: comp.gap || 12,
    }}>
      {comp.showTitle && (
        <div style={{
          fontSize: comp.titleFontSize || 15, fontWeight: comp.titleFontWeight || 600,
          color: comp.titleColor || '#111827',
          paddingBottom: 11,
          borderBottom: comp.showDivider ? `1px solid ${comp.dividerColor || '#E2E5EA'}` : 'none',
        }}>
          {comp.title}
        </div>
      )}
      <div style={{
        flex: 1,
        background: 'repeating-linear-gradient(45deg,#F7F8FA,#F7F8FA 4px,transparent 4px,transparent 16px)',
        borderRadius: 6, minHeight: 50,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: '#9CA3AF', fontSize: 12,
        border: '1px dashed #CDD0D8',
      }}>
        Drop components here
      </div>
    </div>
  );
}
